const VERSION = "2.3.0";
const CSS = `https://cdn.jsdelivr.net/npm/moyasar-payment-form@${VERSION}/dist/moyasar.css`;
const JS = `https://cdn.jsdelivr.net/npm/moyasar-payment-form@${VERSION}/dist/moyasar.umd.min.js`;

let loader = null;

export function loadMoyasar() {
    if (window.Moyasar) return Promise.resolve(window.Moyasar);
    if (loader) return loader;
    loader = new Promise((resolve, reject) => {
        if (!document.querySelector(`link[href="${CSS}"]`)) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = CSS;
            document.head.appendChild(link);
        }
        const script = document.createElement("script");
        script.src = JS;
        script.async = true;
        script.onload = () => resolve(window.Moyasar);
        script.onerror = () => {
            loader = null;
            reject(new Error("load failed"));
        };
        document.body.appendChild(script);
    });
    return loader;
}
